import { Country } from '@afterpay/types'
import { useFlag } from '@afterpaytouch/feature'
import { Features } from '../../model'
import { useIsCountry } from '../country/hooks'

export interface UkRegFlags {
  isUkRegulationEnabled: boolean
  isUkCreditCheckEnabled: boolean
  isUkMarketRegsFCA: boolean
}

export const useUkRegFlags = (): UkRegFlags => {
  const isGbCountry = useIsCountry(Country.GB)
  const ukRegulationFlag = useFlag(Features.CHECKOUT_ENABLE_UK_REGULATION)
  const ukCreditCheckFlag = useFlag(Features.UK_CREDIT_CHECK_ENABLED)
  const ukMarketRegsFCA = useFlag(Features.UK_MRKT_REGS_FCA)

  return {
    isUkRegulationEnabled: isGbCountry && ukRegulationFlag,
    isUkCreditCheckEnabled: isGbCountry && ukCreditCheckFlag,
    isUkMarketRegsFCA: isGbCountry && ukMarketRegsFCA,
  }
}
